import { PAGE_PRODUCTS, PRODUCTS } from "constants/action-types";

export const fetchProducts = (
    key: string,
    cacheKey,
    filters: { [key: string]: any },
    options?: { preview: boolean }
) => ({
    payload: filters,
    meta: { key, cacheKey },
    type: PRODUCTS.FETCH.START,
    options,
});

export const resetProducts = (key: string) => {
    return {
        meta: { key },
        type: PRODUCTS.FETCH.RESET,
    };
};

export const fetchPageProducts = (key: string, filters: { [key: string]: any }, cacheKey?: string) => ({
    payload: filters,
    meta: { key, cacheKey },
    type: PAGE_PRODUCTS.FETCH.START,
});

export const fetchProductsNextPage = (key: string, nextPage, options?: { preview: boolean }) => ({
    meta: { key, nextPage },
    type: PRODUCTS.FETCH.START,
    options,
});
